import axios from 'axios';
import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';
import { getAccountId } from '@/core/utils/extractCookieId';

export interface UsergroupLimits {
  total_posts_limit: number;
  month_posts_limit: number;
  month_posts: number;
  total_month_posts: number;
  posts_collected: number;
  total_group_posts: number;
  total_any_group_posts: number;
  total_listening_posts: number;
  total_proprietary_posts: number;
  total_competitors_proprietary_posts: number;
  total_month_listening_posts: number;
  total_month_proprietary_posts: number;
  total_month_competitors_proprietary_posts: number;
  size: number;
}

export interface CentralLimitResponse {
  usergroup_limits?: UsergroupLimits;
}

class CentralLimitsService {
  private createAuthenticatedAxios() {
    const axiosInstance = axios.create();

    axiosInstance.interceptors.request.use((config) => {
      const token = Cookies.get(CONFIG.AUTH.SSID);

      if (token) {
        config.headers[CONFIG.AUTH.SSID] = token;
      }

      return config;
    });

    return axiosInstance;
  }

  async getLimitByAccountId(accountId?: string): Promise<CentralLimitResponse> {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();
    const resolvedAccountId = accountId ?? getAccountId();

    const url = `${gateway}panels-service/${version}/v2/panels/getlimit/${resolvedAccountId}`;

    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get(url, {
      headers: {
        accept: 'application/json',
      },
    });

    return response.data;
  }
}

const centralLimitsService = new CentralLimitsService();
export default centralLimitsService;
